import { safeSetLocalStorage, useFallbackStorageValue } from "@product/scmp-sdk";
import { useAtomValue } from "jotai";
import { useEffect } from "react";

import { userBookmarkAtom } from "scmp-app/components/content/content-bookmark/atoms";
import { BookmarkedListV1Key } from "scmp-app/components/content/content-bookmark/consts";
import type { UserBookmarkList } from "scmp-app/components/content/content-bookmark/types";
import { userFollowAtom } from "scmp-app/components/follow-button/atoms";
import { UserFollowV1Key } from "scmp-app/components/follow-button/consts";
import type { UserFollowList } from "scmp-app/components/follow-button/types";
import { accountAtom } from "scmp-app/lib/account";

export const useSyncV1Data = () => {
  useV1BookmarkData();
  useV1FollowData();
};

// This hooks is for handling the follow data in v1
const useV1FollowData = () => {
  const { isLoggedIn } = useAtomValue(accountAtom);
  const { data, mutate } = useAtomValue(userFollowAtom);
  const { value: v1Data } = useFallbackStorageValue<UserFollowList>(UserFollowV1Key, {
    initializeWithValue: true,
  });

  useEffect(() => {
    if (!isLoggedIn || !v1Data || !mutate) return;
    void mutate(v1Data);
  }, [isLoggedIn, mutate, v1Data]);

  useEffect(() => {
    data && safeSetLocalStorage(UserFollowV1Key, JSON.stringify(data));
  }, [data]);
};

// This hooks is for handling the bookmark data in v1
const useV1BookmarkData = () => {
  const { data, mutate } = useAtomValue(userBookmarkAtom);
  const { value: v1Data } = useFallbackStorageValue<UserBookmarkList>(BookmarkedListV1Key, {
    initializeWithValue: true,
  });

  const { isLoggedIn } = useAtomValue(accountAtom);
  useEffect(() => {
    if (!isLoggedIn || !v1Data || !mutate) return;
    void mutate(v1Data);
  }, [isLoggedIn, mutate, v1Data]);

  useEffect(() => {
    data && safeSetLocalStorage(BookmarkedListV1Key, JSON.stringify(data));
  }, [data]);
};
